import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import BannerCard from './components/banner-card/banner-card.component'
import ContentCard from './components/content-card/content-card.component'

const MuvicardPage = props => {
	const { user } = props

	return (
		<section>
			<BannerCard logged={user} />
			<ContentCard logged={user} />
		</section>
	)
}

const mapStateToProps = store => ({
	user: store.user
})

const connectedMuvicardPage = withRouter(
	connect(mapStateToProps, null)(MuvicardPage)
)
export { connectedMuvicardPage as ModuleRootComponent }
